import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { RootState } from "app/lib/store/store";
import Layout from "app/components/layouts";
import PartOne from "app/components/joint/assetsLiabilities/PartOne";
import PartTwo from "app/components/joint/assetsLiabilities/PartTwo";
import PartThree from "app/components/joint/assetsLiabilities/PartThree";
import PartFour from "app/components/joint/assetsLiabilities/PartFour";
import PartFive from "app/components/joint/assetsLiabilities/PartFive";
import PartSix from "app/components/joint/assetsLiabilities/PartSix";
import PartSeven from "app/components/joint/assetsLiabilities/PartSeven";
import CarLoan from "app/components/joint/assetsLiabilities/CarLoan";
import JointStepper from "app/components/common/JointStepper";
import { StepsComponent } from "app/utils/types";

const JointAssetsliabilities: React.FC = () => {
  const currentStep = useSelector(
    (state: RootState) => state.jointAssetsLiabilities.currentStep
  );

  const steps = useMemo<StepsComponent[]>(
    () => [
      <PartOne key="assetsLiabilitiesPartOne" />,
      <PartTwo key="assetsLiabilitiesPartTwo" />,
      <PartThree key="assetsLiabilitiesPartThree" />,
      <CarLoan key="assetsLiabilitiesCarLoan" />,
      <PartFour key="assetsLiabilitiesPartFour" />,
      <PartFive key="assetsLiabilitiesPartFive" />, // Step 5: Upload passport image
      <PartSix key="assetsLiabilitiesPartSix" />, // Step 6: Upload driver license
      <PartSeven key="assetsLiabilitiesPartSeven" />, // Step 7: Connect Bank
    ],
    []
  );

  const renderStep = useMemo(() => {
    if (currentStep >= 0 && currentStep < steps.length) {
      return steps[currentStep];
    }
    return <PartOne />;
  }, [currentStep, steps]);
  return (
    <>
      <Layout>
        <JointStepper />
        {renderStep}
      </Layout>
    </>
  );
};
export default JointAssetsliabilities;
